import { render, staticRenderFns } from "./ClientsViewClientStatsCards.vue?vue&type=template&id=342f3178"
import script from "./ClientsViewClientStatsCards.vue?vue&type=script&lang=js"
export * from "./ClientsViewClientStatsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports